import {
  Button,
  ButtonSize,
  ButtonWidth,
  IconFilter,
} from '@leland-dev/leland-ui-library';
import React, { useState } from 'react';

import SearchFilters from './SearchFilters';
import type { SearchFiltersProps } from './SearchFilters';

type MobileSearchFiltersProps = SearchFiltersProps;

const MobileSearchFilters: React.FC<MobileSearchFiltersProps> = (props) => {
  const [showMobileSearchFilters, setShowMobileSearchFilters] = useState(false);

  return (
    <div className="w-full">
      <Button
        label="Filter"
        LeftIcon={IconFilter}
        size={ButtonSize.LARGE}
        width={ButtonWidth.FULL}
        onClick={() => setShowMobileSearchFilters(true)}
      />
      {showMobileSearchFilters ? (
        <div className="fixed inset-0 z-50 overflow-y-scroll bg-white lg:hidden">
          <SearchFilters
            {...props}
            headerClassName="z-5"
            className="w-full"
            onClose={() => setShowMobileSearchFilters(false)}
          />
        </div>
      ) : null}
    </div>
  );
};

export default MobileSearchFilters;
